/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import * as React from 'react';
import { useSelector } from 'react-redux';
import { Ducks } from '@wit/vtv-x-foundation-lib';
import translate from '../../../services/i18n/translate';

const NoticePage: React.FunctionComponent = () => {
  const noticeData = useSelector(Ducks.Faqs.Selectors.getGdprData);
  const isProcessed = useSelector(Ducks.Faqs.Selectors.isProcessed);

  const pageData = {
    title: translate['gdpr.notice.title'],
    text: noticeData?.documents.notice?.text || translate['gdpr.notice.default'],
  };

  const isUserAuthenticated = useSelector(Ducks.Credentials.Selectors.isAuthenticated);

  return (
    <div id="NoticePage" className="component-inner gdpr">
      <h2 id="NoticePage_title">{pageData.title}</h2>
      <div className="gdpr-container">
        <div className="left-info">
          {isUserAuthenticated && (
            <div id="NoticePage_status" className="status">
              <span>{translate['gdpr.status.agreed']}</span>
              <span className="status-img" />
            </div>
          )}
        </div>
        <div className="right-info">
          {isProcessed && pageData?.text && (
            <div id="NoticePage_text" className="text">
              <span>{pageData?.text}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NoticePage;
